import React, { useEffect, useRef, useState } from "react"
import { useSearchParams } from "../../../../hooks/useSearchParams"
import Esign from "../Esign"
import useToggle from "../../../../hooks/toggle"
import { selecteddocumentesign } from "../ReviewDocs"
import { useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import { ALAlimited, getexternaldocuments, getSavedOfferDetails } from "../../../../api/transaction"
import { useReactToPrint } from 'react-to-print';
import { CSpinner } from "@coreui/react"
const ALALimitedDueagency = () => {
    const {id,user} : any = useParams()
    const componentRef = useRef();
    const [limitedagency, setLimitedAgency] = useState({
        offer_id: Number(id),
        property_address: "",
        seller1: "",
        seller1_date: null,
        seller2: "",
        seller2_date: null,
        buyer1: "",
        buyer1_date: null,
        buyer2: "",
        buyer2_date: null,
        agent1: "",
        agent1_date: null
    })

    const [loader,setloading] = useState(false)
    const [canvasmodal, setCanvasModal] = useToggle(false);
const [htmlContent, setHtmlContent] = useState("");
const [offerdetails, setOfferDetails] = useState({});
const [selecteddocumentesign, setselectedDocumentEsign] = useState<selecteddocumentesign>({
    offerid : "",
  document_name: "",
  image_base64: "",
  sign_role: 1
  })
// @ts-ignore
  const val = useSelector((state)=>state?.new?.signset)
  const printf = () => {
    // window.print()
    handlePrint()
};

useEffect(()=>{
    (async function () {
        let offerdetails = await getSavedOfferDetails(id)
    setOfferDetails(offerdetails[0])
    })()
    
},[])


useEffect(()=>{
    if(val){
        if(user == "seller"){
            setLimitedAgency({ ...limitedagency, seller1: val })
        }
        if(user == "client"){
            setLimitedAgency({ ...limitedagency, buyer1: val })
        }
    }
    },[val])

const send = async()=>{
    setloading(true)
    if(user === "seller"){
       
        if(limitedagency?.seller1){
            let res =await ALAlimited(limitedagency)
            if(res?.status == "success"){
                alert("Submitted Successfully")
            }
            else{
                alert("Something went wrong")
            }
        }
    }
    else if(user==="client"){

        if(limitedagency?.buyer1){
            let res =await ALAlimited(limitedagency)
            if(res?.status == "success"){
                alert("Submitted Successfully")
            }
            else{
                alert("Something went wrong")
            }
        }
    }
    setloading(false)
}   

useEffect(()=>{
    (async function(){
        let offerdetails = await getSavedOfferDetails(id)
        setOfferDetails(offerdetails[0])
      const res =await getexternaldocuments(id,"limiteddualagency") 
      setLimitedAgency({...limitedagency,
        property_address: res?.data?.property_address,
        seller1: res?.data?.seller1,
        seller1_date: res?.data?.seller1_date,
        seller2: res?.data?.seller2,
        seller2_date: res?.data?.seller2_date,
        buyer1: res?.data?.buyer1,
        buyer1_date: res?.data?.buyer1_date,
        buyer2: res?.data?.buyer2,
        buyer2_date: res?.data?.buyer2_date,
        agent1: res?.data?.agent1,
        agent1_date: res?.data?.agent1_date
      })
    })()
  },[])

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

    return (
        <>
            <>
                <section style={{ pageBreakAfter: "always" }} ref={componentRef}>
                    <table
                        style={{ width: 1100, margin: "0 auto", background: "#fff", padding: 30 }}
                    >
                        <tbody>
                            <tr>
                                <td>
                                    <table style={{ width: "100%" }}>
                                        <tbody>
                                            <tr>
                                                <td style={{ width: "90%" }}>
                                                    <img
                                                        style={{ width: 250 }}
                                                        src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                                                    />
                                                </td>
                                                <td>
                                                    <img
                                                        style={{ width: 30 }}
                                                        src="https://storagemilforddev.blob.core.windows.net/images/realtor.svg"
                                                        alt=""
                                                    />
                                                    <img
                                                        style={{ width: 50 }}
                                                        src="https://storagemilforddev.blob.core.windows.net/images/eh.svg"
                                                        alt=""
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span style={{ fontSize: 25, fontWeight: 700 }}>
                                        Informed Written Consent and Limited Dual Agency Agreement
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "20px 0px" }}>
                                    <span style={{ fontWeight: 600 }}>
                                        (This is a legally binding contract. If not understood, seek legal
                                        advice.)
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>
                                        This Informed Written Consent and Limited Dual Agency Agreement
                                        pertains to the (“Property”) located at:
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>
                                        <input
                                            type="text"//@ts-ignore
                                            value={offerdetails?.propertyAddress}
                                            onChange={(e) => setLimitedAgency({ ...limitedagency, property_address: e.target.value })}
                                            style={{
                                                outline: "none",
                                                border: "none",
                                                borderBottom: "1px solid black",
                                                width: "100%"
                                            }}
                                        />
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "20px 0px" }}>
                                    <span>
                                        Milford Real Estate (“Broker”) permits the licensee named herein
                                        (“Sales Associate”) to act as an agent for sellers of property as
                                        a Seller‘s Limited Agent (“Seller’s Agent”) and to act as an agent
                                        for buyers of property as a Buyer’s Limited Agent (“Buyer’s
                                        Agent”)
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "20px 0px" }}>
                                    <span>
                                        A buyer represented by the Sales Associate as Buyer’s Agent may
                                        become interested in a property listed for sale by Sales Associate
                                        representing the seller as Seller’s Agent. When this happens,
                                        Broker also permits the Sales Associate to act as a Limited Dual
                                        Agent (“Dual Agent”) for both the buyer and the seller of a
                                        particular property representing each as clients, but only with
                                        the informed written consent of both the buyer and seller of that
                                        property. Sales Associate must promptly notify both the potential
                                        buyer and the seller when a represented buyer becomes interested
                                        in purchasing a represented seller’s property.
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "20px 0px" }}>
                                    <span>
                                        Buyer and Seller each acknowledge: 1.) That Broker and Sales
                                        Associate represent both Buyer and Seller; 2.) That Buyer is now
                                        interested in purchasing Seller’s property; 3.) That Sales
                                        Associate will be the Dual Agent of both Buyer and Seller, but
                                        only if both consent to the Dual Agency; 4.) That Broker and Sales
                                        Associate will be compensated by Seller under the term of Seller’s
                                        listing agreement with Broker; and 5.) That a Limited Dual Agent
                                        owes the following duties and obligations to both Buyer and Seller
                                        when serving both as clients
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "15px 0px 15px 40px" }}>
                                    <span>
                                        ( a ) To perform the terms of the written agreement made with the
                                        Buyer and Seller
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "15px 0px 15px 40px" }}>
                                    <span>
                                        ( b ) To exercise reasonable skill and care for the Buyer and
                                        Seller.
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "20px 0px 20px 70px" }}>
                                    <span>
                                        1. Seeking a price and terms which are acceptable to both Buyer
                                        and Seller, except that licensee shall not be obligated to seek
                                        other properties for Buyer or other buyers for Property while the
                                        Buyer and Seller are party to a contract to purchase Property.
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "20px 0px 20px 70px" }}>
                                    <span>
                                        2. Presenting all written offers to and from Seller and Buyer in a
                                        timely manner, regardless of whether the Seller is already a party
                                        to a contract to purchase Property;
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "20px 0px 20px 70px" }}>
                                    <span>
                                        3. Disclosing in writing to the Seller and Buyer adverse material
                                        facts actually known by the Dual Agent; and
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "20px 0px 20px 70px" }}>
                                    <span>
                                        4. Advising Seller and Buyer to obtain expert advice as to
                                        material
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "15px 0px 15px 40px" }}>
                                    <span>
                                        ( d ) To account in a timely manner for all money and property
                                        received;
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "15px 0px 15px 40px" }}>
                                    <span>
                                        ( e ) To comply with the requirements of sections 76-2401 to
                                        76-2430, the Nebraska Real Estate License Act, and any rules and
                                        regulations promulgated pursuant to such sections or act; and
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "10px 0px 10px 40px" }}>
                                    <span>
                                        ( f ) To comply with any applicable federal, state, and local
                                        laws, rules, regulations, and ordinances, Including fair housing
                                        and civil rights statutes and regulations.
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </section>
                <section>
                    <table
                        style={{ width: 1100, margin: "0 auto", background: "#fff", padding: 30 }}
                    >
                        <tbody>
                            <tr>
                                <td>
                                    <table style={{ width: "100%" }}>
                                        <tbody>
                                            <tr>
                                                <td style={{ width: "90%" }}>
                                                    <img
                                                        style={{ width: 250 }}
                                                        src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>
                                        A Dual Agent also continues to owe to the Seller and Buyer the
                                        duties and obligations described above, except that a Dual Agent
                                        can disclose to one client any Information the Dual Agent has
                                        gained from the other client which is relevant to the transaction
                                        or client provided that the Dual Agent cannot disclose, without
                                        the informed written consent of the client to whom the information
                                        pertains:
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "15px 0px 15px 40px" }}>
                                    <span>
                                        ( b ) That Buyer is willing to pay more than the purchase price
                                        offered for the Property;
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "15px 0px 15px 40px" }}>
                                    <span>
                                        ( c ) What motivating factors are for any client buying or selling
                                        the Property;
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "15px 0px 15px 40px" }}>
                                    <span>
                                        ( d ) That either client will agree to financing terms other than
                                        those offered by that client; and
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "15px 0px 15px 40px" }}>
                                    <span>
                                        ( e ) Any other confidential Information about the client unless
                                        the disclosure is required by statute, rule, or regulation or
                                        failure to disclose the information would constitute fraudulent
                                        misrepresentation.
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span style={{ fontWeight: 600, color: "#3b0083" }}>
                                        Seller and Buyer each acknowledge that both the Sales Associate
                                        and Broker now function as Limited Dual Agents for this
                                        transaction, and Seller and Buyer hereby consent and agree to this
                                        Dual Agency in which each will be represented as clients
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "15px 0px" }}>
                                    <table style={{width: "100%"}}>
                                        <tbody>
                                            <tr>
                                                <td style={{width:"40%"}}>
                                                <span style={{ paddingRight:".5rem" }}>Seller</span>
                                                    <span>
                                                        <img
                                                            src={user === "seller" ? val || limitedagency?.seller1 : limitedagency?.seller1}

                                                            style={{
                                                                outline: "none",
                                                                border: "none",
                                                                borderBottom: "2px solid #3b0083",
                                                                width: 200
                                                            }}
                                                        />
                                                    </span>
                                                    
                                                    <input type="date" value={limitedagency?.seller1_date? limitedagency?.seller1_date : (user === "seller" && val || limitedagency?.seller1) ? new Date().toISOString().split('T')[0] : ""}
                                                    onChange={(e)=>setLimitedAgency({...limitedagency,seller1_date:e.target.value})}
                                                    />
                                                    Date    
                                                </td>
                                                <td style={{width:"40%"}}>
                                                <span style={{ paddingRight: ".5rem" }}>Buyer</span>
                                                     <span>
                                                     <img
                                                        src={user === "client" ? val || limitedagency?.buyer1 : limitedagency?.buyer1}

                                                            style={{
                                                                outline: "none",
                                                                border: "none",
                                                                borderBottom: "2px solid #3b0083",
                                                                width: 200
                                                            }}
                                                        />
                                                         
                                                    </span> 
                                                    
                                                    <input type="date" value={limitedagency?.buyer1_date ? limitedagency?.buyer1_date : (user === "client" && val || limitedagency?.buyer1) ? new Date().toISOString().split('T')[0] : ""}
                                                    onChange={(e)=>setLimitedAgency({...limitedagency,buyer1_date:e.target.value})}
                                                    />
                                                         Date
                                                         </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "15px 0px" }}>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td style={{ textAlign: "center" }}>
                                                    <span>
                                                        <input
                                                            type="text"
                                                            style={{
                                                                outline: "none",
                                                                border: "none",
                                                                borderBottom: "2px solid #3b0083",
                                                                width: 500
                                                            }}
                                                        />
                                                    </span>
                                                    <span style={{ paddingRight: 250 }}>    </span>Date
                                                </td>
                                                <td style={{ textAlign: "center" }}>
                                                    <span>
                                                        <input
                                                            type="text"
                                                            style={{
                                                                outline: "none",
                                                                border: "none",
                                                                borderBottom: "2px solid #3b0083",
                                                                width: 500
                                                            }}
                                                        />
                                                    </span>
                                                    <span style={{ paddingRight: 250 }}> Buyer </span>Date
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "15px 0px" }}>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td style={{ textAlign: "center" }}>
                                                    <span>
                                                        <input
                                                            type="text"
                                                            style={{
                                                                outline: "none",
                                                                border: "none",
                                                                borderBottom: "2px solid #3b0083",
                                                                width: 500
                                                            }}
                                                        />
                                                    </span>
                                                    <br />
                                                    <span style={{ paddingRight: 250 }}> Seller</span>Date
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ paddingTop: 50 }}>
                                    <span>
                                        Other provisions: Earnest deposit to be delivered within (5)
                                        business days.
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </section>
            </>
            <React.Fragment>
<div className="d-flex align-items-center justify-content-end mb-2 mr-2">
    <button onClick={send} className="btn primaryColorBtn">Submit
    {loader && <CSpinner color="dark" size="sm" className={'ml-1'} />}
    </button>
    <button onClick={printf} className="btn print-doc-btn mx-2">Print</button>
    <button className="signaturebtn btn mb-0" onClick={() => setCanvasModal()}>Signature</button> 
</div>
          </React.Fragment>
<Esign
        canvasmodal={canvasmodal}
        setCanvasModal={setCanvasModal}
        htmlContent={htmlContent}
        setHtmlContent={setHtmlContent}
        selecteddocumentesign={selecteddocumentesign}
        setselectedDocumentEsign={setselectedDocumentEsign}
        type={"seller"}
      ></Esign>
        </>
    )
}

export default ALALimitedDueagency